common.View.create('canvas.blocks.sky.scrollUpAlfa.Block', {

    onDOMLoad() {
        this.initAppearAfterScroll();
        this.initScrollUp();
    },

    initAppearAfterScroll() {
        // Add listener for scroll
        let timeout;

        // Add listener for scroll
        $(window).scroll(() => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                this.showOrHideElement();
            }, 50);
        });

        // Show or hide element on load
        this.showOrHideElement();
    },

    showOrHideElement()
    {
        // Check if footer is in sight
        if (window.scrollY >= 300) {
            // Hide element with fade
            this.element.find('.button').fadeIn('fast');
        } else {
            // Show element with fade
            this.element.find('.button').fadeOut('fast');
        }
    },

    initScrollUp()
    {
        this.element.find('.button')
            .on('click', (event) => {
                // Scroll up (with animation)
                $("html, body").animate({ scrollTop: 0 }, "fast");

                return false;
            })
    }
});
